var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM14.9824 7.02572L12.4824 4.92572C12.2035 4.69143 11.7965 4.69143 11.5176 4.92572L9.01761 7.02572C8.70044 7.29214 8.6593 7.76523 8.92572 8.08239C9.19214 8.39956 9.66523 8.4407 9.98239 8.17428L11.25 7.10949V10.5C11.25 10.9142 11.5858 11.25 12 11.25C12.4142 11.25 12.75 10.9142 12.75 10.5V7.10949L14.0176 8.17428C14.3348 8.4407 14.8079 8.39956 15.0743 8.08239C15.3407 7.76523 15.2996 7.29214 14.9824 7.02572ZM12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75C11.5858 12.75 11.25 13.0858 11.25 13.5V16.7403L10.0194 15.559C9.72059 15.2721 9.24582 15.2818 8.95896 15.5806C8.6721 15.8794 8.68179 16.3542 8.9806 16.641L11.4806 19.041C11.757 19.3064 12.189 19.3207 12.4824 19.0743L14.9824 16.9743C15.2996 16.7079 15.3407 16.2348 15.0743 15.9176C14.8079 15.6004 14.3348 15.5593 14.0176 15.8257L12.75 16.8905V13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpand);
export default __webpack_public_path__ + "static/media/arrow-expand.f1f32d85f2c297e8b0ecccdc80cbc679.svg";
export { ForwardRef as ReactComponent };